// Description: Page to create one Email template
// Updated: 20/08/2025
// Author: Vitor de Jesus

// React
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

// Material UI Components
import { Box, Grid, TextField, FormControl, useMediaQuery, Button, Typography } from '@mui/material';

// Components and Functions for the project
import use123zapStore from '../../context/123zapStore';
import CampaignModal from '../../components/Modals/CampaignModal';
import HeaderPage from '../../components/HeaderPage/HeaderPage';
import { isAuthenticated } from '../../authMiddleware';
import { CreateTemplate } from '../../api/aws/Templates/CreateTemplate';
import { notify } from '../../utils/utils';
import ViewWhatsAppScreen from '../../components/WhatsAppScreen/ViewWhatsAppScreen';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';
import themeColors from '../../components/ThemeColors/ThemeColors';
import { GetVariables } from '../../api/aws/Listagens/GetVariables';
import TemplateInput from '../../components/Input/TemplateInput';
import DynamicButton from '../../components/DynamicButton/DynamicButton';
import ThemeColors from '../../components/ThemeColors/ThemeColors';
import EmailFormShowCase from '../../components/EmailFormShowCase/EmailFormShowCase';

// Render The Component
const FormEmailNew = () => {

    const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
    const planoAtual = use123zapStore((state) => state.planoAtual);
    const userInfo = use123zapStore((state) => state.userInfo);
    const setUserInfo = use123zapStore((state) => state.setUserInfo);
    const setAlreadyFetchTemplates = use123zapStore((state) => state.setAlreadyFetchTemplates);
    const Navigate = useNavigate();

    const creatingCampaignWithHelpMode = JSON.parse(sessionStorage.getItem("creating_campaign")) || null;
    const [title, setTitle] = useState('');
    const isSmallScreen = useMediaQuery('(max-width:1200px)');
    const [showPreview, setShowPreview] = useState(false);
    const [openModalCampaign, setOpenModalCampaign] = useState(false);
    const [emailTitle, setEmailTitle] = useState('');
    const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
    const [messageTemporary, setMessageTemporary] = useState('');
    const typeChannel = "e-mail";
    const [showLoading, setShowLoading] = useState(true);
    const buttons = ['Atrasos', 'Avisos', 'Faturas', 'Inadimplências', 'Marketing', 'Outros'];

    const [viewWhatsAppScreenProps, setViewWhatsAppScreenProps] = useState({
        messages: {
            messages: []
        }
    });

    useEffect(() => {
        if (userAuthenticated && Object.keys(userInfo).length === 0) {
            const { decryptedData } = isAuthenticated();
            setUserInfo(decryptedData);
        }
    }, [userAuthenticated, userInfo]);

    useEffect(() => {
        if (userInfo['UUID']) {
            fetchData();
        }
    }, [userInfo])

    useEffect(() => {
        if (planoAtual !== 'UltraZap' && planoAtual !== 'ProZap') {
            Navigate('/acesso-restrito');
        }
    }, [planoAtual]);

    useEffect(() => {
        setViewWhatsAppScreenProps((prevProps) => ({
            ...prevProps,
            type: 'e-mail',
            messages: {
                messages: [],
            },
        }));

        setMessageTemporary('');

    }, [typeChannel]);

    useEffect(() => {
        setViewWhatsAppScreenProps((prevProps) => ({
            ...prevProps,
            messages: {
                messages: [{ id: prevProps.messages.messages.length + 1, type: 'e-mail', message: messageTemporary, fromMe: true, disabledRemove: true }],
            },
        }));

    }, [messageTemporary]);

    const [selected, setSelected] = useState('Atrasos');
    const handleClick = (button) => {
        setSelected(button);
    }

    const fetchData = async () => {
        try {
            const translations = {
                "Personal_information": "Informações Pessoais",
                "Contact": "Contato",
                "Address": "Endereço",
                "Financial_References": "Referências Financeiras"
            };

            const resultJson = await GetVariables();

            console.log('resultJson', resultJson);

            const result = resultJson.data.reduce((acc, item) => {
                const category = translations[item.category] || item.category;
                if (!acc[category]) {
                    acc[category] = [];
                }

                acc[category].push(item.variableName);

                return acc;
            }, {});

            setVariablesOfTemplate(result);

        } catch (error) {
            console.error('Error fetching data from API:', error);
        } finally {
            setShowLoading(false);
        }
    };

    const saveTemplate = async () => {

        const get_messages = viewWhatsAppScreenProps.messages.messages.map((message) => {
            return {
                type: 'html',
                title: emailTitle,
                content: message.message
            };
        });

        let info = {};

        info = {
            'title': title,
            'messages': get_messages,
            'msg_type': selected,
            'channel_type': 'E-mail',
        };

        info = JSON.stringify(info);

        const resultJson = await CreateTemplate(info);

        if (resultJson['status'] === 'success') {
            notify("Success", "Modelo criado com sucesso!", true);
            setAlreadyFetchTemplates(false);
            creatingCampaignWithHelpMode === true ? setOpenModalCampaign(true) : Navigate("/modelos");
        }
    }

    const verifyFieldsBeforeSave = async () => {
        if (title === "") {
            notify("Error", "Preencha o título do modelo", true);
        } else if (emailTitle === "") {
            notify("Error", "Preencha o título do e-mail", true);
        } else if (messageTemporary === "") {
            notify("Error", "Escreva uma mensagem antes de salvar o modelo", true);
        } else {
            await saveTemplate();
        }
    }

    if (showLoading) {
        return <Loading open={true} />;
    }

    return (
        <>
            <HeaderPage />
            <Box sx={{ background: "#F7F7FC" }}>
                <Grid container spacing={2} style={{ paddingTop: '20px' }}>
                    <Grid item xs={12} lg={6} xl={6} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Box sx={{ flexGrow: 1, justifyContent: 'center', backgroundColor: '#F7F7FC', width: { xs: 'calc(100% - 20px)', sm: "561.200px", lg: "90%" }, margin: { xs: '0 auto 20px', lg: '0 auto' }, padding: { xs: 0, lg: "20px 0px 20px 30px", xl: "20px" } }}>
                            <FormControl fullWidth>
                                <TextField
                                    id="outlined-basic"
                                    label="Nome do seu Modelo"
                                    variant="standard"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    InputLabelProps={{
                                        style: { fontSize: '20px' }
                                    }}

                                />
                            </FormControl>

                            <Box item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                {buttons.map((button, index) => (
                                    <Button
                                        key={button}
                                        onClick={() => handleClick(button)}
                                        sx={{
                                            flexGrow: 1,
                                            mx: index === 0 || index === buttons.length - 1 ? 0 : 0.5,
                                            bgcolor: selected === button ? '#8142FC' : ThemeColors.gray30,
                                            color: '#fff',
                                            borderRadius: '27px',
                                            '&:hover': { bgcolor: selected === button ? '#8142FC' : 'gray' },
                                            fontSize: { xs: '11px', xl: '12px' },
                                            padding: { xs: '3px 12px', xl: '4px 16px' }
                                        }}
                                    >
                                        {button}
                                    </Button>
                                ))}
                            </Box>

                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                gap={"5px"}
                                minWidth={"100%"}
                                sx={{ paddingTop: '20px', display: 'flex', flexDirection: 'column', gap: '5px' }}
                            >
                                <Typography

                                    color={"#52525B"}
                                    sx={{
                                        fontSize: { xs: '18px', sm: '18px' },
                                        fontWeight: 500,
                                        fontFamily: 'Satoshi',
                                        marginBottom: '5px'
                                    }}

                                >Título do Email (assunto)
                                </Typography>

                                <TextField
                                    placeholder="Digite o título aqui :)"
                                    fullWidth
                                    rows={1}
                                    variant="outlined"
                                    value={emailTitle}
                                    onChange={(e) => setEmailTitle(e.target.value)}
                                    autoComplete="off"
                                    style={{
                                        background: "white",
                                        color: "black",
                                        borderRadius: "12px",
                                        margin: 0,
                                        border: `1px solid ${themeColors.gray20}`,
                                        color: themeColors.gray40,
                                    }}
                                    sx={{
                                        ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                            padding: "14px",
                                        },
                                        ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                            borderRadius: "6px",
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ paddingTop: { xs: '20px', sm: '0px' }, marginBottom: (isSmallScreen && showPreview) ? '20px' : 'none', position: 'relative' }}>
                                <Box sx={{
                                    color: 'rgb(129, 66, 252)',
                                    fontSize: '18px',
                                    position: 'absolute',
                                    top: { xs: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px', sm: (typeChannel === 'WhatsApp' || typeChannel === 'SMS') ? '16px' : (typeChannel === 'E-mail' && showPreview) ? '16px' : '0px' },
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    display: isSmallScreen ? 'block' : 'none',
                                    fontFamily: 'Satoshi',
                                    cursor: 'pointer',
                                    zIndex: '10'
                                }} onClick={() => setShowPreview(prev => !prev)}>
                                    {
                                        !showPreview ? "Exibir Prévia" : "Esconder Prévia"
                                    }
                                </Box>

                                <Box sx={{
                                    display: (isSmallScreen && showPreview) ? 'none' : 'block'
                                }}>
                                    <Grid container spacing={2} style={{ marginTop: '20px' }}>
                                        <TemplateInput type={'email'} value={messageTemporary} handleChange={setMessageTemporary} variablesOfTemplate={variablesOfTemplate} />

                                        <Grid item xs={6}>
                                            <FormControl fullWidth sx={{ justifyContent: 'flex-end' }}>
                                                <DynamicButton handleFunction={verifyFieldsBeforeSave} style={{ width: '100%', padding: '13px' }} variant={"contained"} text={"Salvar Modelo"} />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Box>

                            <Box sx={{ display: { xs: 'none', lg: 'flex' }, justifyContent: 'start', alignItems: 'end', minHeight: '80px' }}>
                                <Footer />
                            </Box>
                        </Box>
                    </Grid>
                    {
                        (isSmallScreen && showPreview === true) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <EmailFormShowCase title={emailTitle} titleModel={title} message={messageTemporary} />
                            </Grid>
                        ) : (!isSmallScreen) ? (
                            <Grid item xs={12} lg={6} xl={6} padding={{ xs: "0 0 20px 0", lg: "0", xl: "0" }}>
                                <EmailFormShowCase title={emailTitle} titleModel={title} message={messageTemporary} />
                            </Grid>
                        ) : null
                    }
                    <Box sx={{ padding: { xs: "20px 0 0 25px", sm: "20px 0 0 0" }, display: { xs: "block", lg: "none" }, width: { xs: "100%", sm: "561.200px", lg: "100%", xl: "100%" }, margin: { sm: "0 auto", lg: "0", xl: "0" } }}>
                        <Footer />
                    </Box>
                </Grid>
            </Box>
            <CampaignModal
                cancelText="Criar mais um modelo"
                confirmText="Retornar ao formulário"
                subTitle={"Percebemos que você está configurando uma campanha. Gostaria de retornar ao formulário?"}
                isOpen={openModalCampaign}
                onClose={() => setOpenModalCampaign(false)}
                onCancel={() => Navigate("/modelos/canal")}
                onConfirm={() => (Navigate("/campanhas/adicionar"), sessionStorage.setItem("ReturToCampaign", true))}
                title={"Modelo criado com sucesso"}
                iconColor={ThemeColors.purple400}
            />
        </>
    )
}

export default FormEmailNew